import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: () => import('@/views/login/index.vue'), meta: { title: '登录', auth: false } },
  { path: '/auto-login', component: () => import('@/views/login/autoLogin.vue'), meta: { title: '家政服务', auth: false } },
  {
    path: '/',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/home',
    children: [
      { path: 'home', component: () => import('@/views/home/index.vue'), meta: { title: '家政服务首页', tabbar: true } },
      { path: 'order', component: () => import('@/views/order/list.vue'), meta: { title: '我的订单', tabbar: true } },
      { path: 'mine', component: () => import('@/views/mine/index.vue'), meta: { title: '我的', tabbar: true } }
    ]
  },
  { path: '/service/list', component: () => import('@/views/service/list.vue'), meta: { title: '服务列表' } },
  { path: '/service/category', component: () => import('@/views/service/category.vue'), meta: { title: '选择服务分类' } },
  { path: '/service/spec', component: () => import('@/views/service/spec.vue'), meta: { title: '选择规格' } },
  { path: '/service/sku-list', component: () => import('@/views/service/sku-list.vue'), meta: { title: '服务列表' } },
  { path: '/service/detail/:skuId', component: () => import('@/views/service/detail.vue'), meta: { title: '服务详情' } },
  { path: '/service/match', component: () => import('@/views/service/match.vue'), meta: { title: '快速下单' } },
  { path: '/order/create', component: () => import('@/views/order/create.vue'), meta: { title: '确认下单' } },
  { path: '/order/pay-result', component: () => import('@/views/order/payResult.vue'), meta: { title: '支付结果' } },
  { path: '/order/detail/:id', component: () => import('@/views/order/detail.vue'), meta: { title: '订单详情' } },
  { path: '/subscribe/list', component: () => import('@/views/subscribe/list.vue'), meta: { title: '订阅管理' } },
  { path: '/subscribe/detail/:id', component: () => import('@/views/subscribe/detail.vue'), meta: { title: '订阅详情' } },
  { path: '/review/my', component: () => import('@/views/review/list.vue'), meta: { title: '我的评价' } },
  { path: '/review/create/:orderId', component: () => import('@/views/review/create.vue'), meta: { title: '评价服务' } },
  { path: '/suggestion/create/:orderId', component: () => import('@/views/suggestion/create.vue'), meta: { title: '提交建议' } },
  { path: '/suggestion/detail/:id', component: () => import('@/views/suggestion/detail.vue'), meta: { title: '建议详情' } },
  // 兼容旧路由
  { path: '/dispute/create/:orderId', component: () => import('@/views/dispute/create.vue'), meta: { title: '提交建议' } },
  { path: '/dispute/detail/:id', component: () => import('@/views/dispute/detail.vue'), meta: { title: '建议详情' } },
  { path: '/address/list', component: () => import('@/views/address/list.vue'), meta: { title: '我的地址' } },
  { path: '/address/edit/:id?', component: () => import('@/views/address/edit.vue'), meta: { title: '编辑地址' } },
  { path: '*', redirect: '/home' }
]

const router = new VueRouter({ mode: 'hash', base: '/', routes })

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'WTB家政服务'

  // 监听小程序支付结果
  if (to.query.payResult === 'success') {
    // 订阅支付
    if (to.query.isSubscribe === 'true') {
      const subscribeId = to.query.subscribeId || sessionStorage.getItem('payingSubscribeId')
      sessionStorage.removeItem('payingSubscribeId')
      // 跳转到订阅列表或详情页
      next({ path: '/subscribe/list', query: { paySuccess: '1' }, replace: true })
      return
    }
    // 普通订单支付
    const orderId = to.query.orderId || sessionStorage.getItem('payingOrderId')
    const orderNo = to.query.orderNo || sessionStorage.getItem('payingOrderNo')
    sessionStorage.removeItem('payingOrderId')
    sessionStorage.removeItem('payingOrderNo')
    next({ path: '/order/pay-result', query: { orderId, orderNo }, replace: true })
    return
  }

  const needAuth = to.meta.auth !== false
  const token = store.getters.token
  if (needAuth && !token) {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router

